module.exports = __webpack_public_path__ + "static/media/Högskolanpååland-alt.61acd8b0.webp";